import { createNamedContext } from "./createNamedContext";
const EnvironmentContext = createNamedContext("EnvironmentContext", {});
export { EnvironmentContext };
